export enum OrdersRoutePathsEnum {
  ORDER = 'orders/:orderId',
  ORDERS = 'orders',
}
